import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { AuthContext } from '../AuthContext';
import { normalizeBillingSubscription } from '../billingPresentation';

const usePremiumEntitlement = (enabled = true) => {
  const { axiosInstance } = useContext(AuthContext);
  return useQuery({
    queryKey: ['billing-subscription'],
    queryFn: async () => {
      const response = await axiosInstance.get('/api/billing/subscription');
      return normalizeBillingSubscription(response.data);
    },
    enabled,
    retry: 1,
    staleTime: 30000,
    refetchOnMount: true,
  });
};

export default usePremiumEntitlement;
